import Reveal from "./Reveal";
import { IMAGES, whatsappLink } from "@/constants/site";

const CARDS = [
  {
    image: IMAGES.sauna,
    alt: "Düzbağ Life sauna alanı",
    title: "Sauna",
    text: "Sıcaklığıyla kaslarınızı gevşeten, günün yorgunluğunu geride bırakacağınız sauna.",
  },
  {
    image: IMAGES.hammam,
    alt: "Düzbağ Life Türk hamamı",
    title: "Türk Hamamı",
    text: "Mermer dokusu ve huzurlu atmosferiyle geleneksel Türk hamamı deneyimi.",
  },
  {
    image: IMAGES.pool,
    alt: "Düzbağ Life kapalı yüzme havuzu",
    title: "Havuz",
    text: "Serinlemek ve dinlenmek için kapalı yüzme havuzu alanı.",
  },
  {
    image: IMAGES.massage,
    alt: "Düzbağ Life dinlenme ve bakım alanı",
    title: "Dinlenme & Bakım Alanı",
    text: "Doğayla geçen bir günün ardından kendinize zaman ayırabileceğiniz sakin alan.",
  },
];

export default function Wellness() {
  const waLink = whatsappLink(
    "Merhaba Düzbağ Life, spa ve wellness alanları hakkında detaylı bilgi almak istiyorum."
  );

  return (
    <section id="spa" className="w-full bg-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <Reveal className="max-w-3xl">
          <span className="text-secondary-600 text-xs tracking-[0.3em] uppercase">
            Spa & Wellness
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.15] font-medium">
            GÜNÜN YORGUNLUĞUNU
            <br />
            GERİDE BIRAKIN
          </h2>
          <p className="mt-6 text-foreground-700 text-base md:text-lg leading-relaxed">
            Doğayla geçen bir günün ardından kendinize zaman ayırabileceğiniz
            wellness alanlarını keşfedin.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((card, index) => (
            <Reveal key={card.title} delay={(index % 4) * 90}>
              <article className="group h-full bg-background-50 rounded-lg overflow-hidden border border-background-300/60">
                <div className="w-full h-[260px] md:h-[320px] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.alt}
                    title="Düzbağ Life spa ve wellness"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-2xl text-foreground-950 font-medium">
                    {card.title}
                  </h3>
                  <div className="mt-3 h-px w-10 bg-secondary-500" />
                  <p className="mt-4 text-foreground-600 text-sm leading-relaxed">
                    {card.text}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-12">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg" />
            Detaylı Bilgi Al
          </a>
        </Reveal>
      </div>
    </section>
  );
}